import { Component, HostListener, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  ActivationEnd,
  ActivationStart,
  NavigationEnd,
  Router,
  NavigationStart,
} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'cacaulovers';
  logado: boolean = false;
  carregandoComponentes: boolean = false;

  constructor(private router: Router) {
    const paginas: string[] = [
      'home',
      'esquecisenha',
      'resetarsenha',
      'saibamais',
      'atendimento',
      'remocao',
    ];

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.carregandoComponentes = true;
      }
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        for (let i = 0; i < paginas.length; i++) {
          if (url.includes(paginas[i])) {
            this.logado = false;
            return;
          }
        }
        this.logado = true;
      }

      this.carregandoComponentes = false;
    });
  }

  ngOnInit(): void { }
}
